<template>
	<aside class="sidebar-left-wrap">
		<div class="boxSearch d-none-lg">
			<img src="../../assets/icon/search-sm.svg" alt="search">
			<input type="text" placeholder="Search Page" />
		</div>
		<div class="sidebar-left">
			<ul>
				<li @click="selectedBox=''">
					<div class="box" :class="[selectedBox ? '' : 'active']" style="background-image:linear-gradient(to right bottom, rgb(141, 170, 253), rgb(123, 187, 255), rgb(120, 201, 251), rgb(133, 213, 244), rgb(155, 223, 237))"></div>
					<div class="number">1</div>
				</li>
				<draggable v-model="boxes" :handle="handle">
	              <transition-group>
			    		<li v-for="(box, index) in boxes" :key="box.id" @click="selectBox(index,box)" :class="[selectedBox.id!=box.id ? 'draggableTrue' : '']">

							<div class="box" :class="[selectedBox.id==box.id ? 'active' : '']" :style="{ background: box.background }"></div>
							<div class="number">{{ index+2 }}</div>
						</li>
					</transition-group>
				</draggable>
			</ul>
			<button data-v-step="0" class="plus-btn" @click="addBox(boxes.length)"><img src="../../assets/icon/add-page.svg"></button>
		</div>
	</aside>
</template>

<script>

import draggable from 'vuedraggable';
export default {
	name:'sidebar-left',
	data(){
		return{
			handle:'.draggableTrue',
			selectedIndex:0,
        	selectedBox:{
	        	id:1,
	        	background: 'linear-gradient(to right bottom, #fc9fe1, #fdafe6, #febfeb, #ffcef0, #ffddf5)'
	        },

	        boxes:[
	        	{
	        		id:1,
	        		background: 'linear-gradient(to right bottom, #fc9fe1, #fdafe6, #febfeb, #ffcef0, #ffddf5)'
	        	}
	        ],
		}
	},

	methods:{
    	selectBox(index,box){
    		this.selectedIndex=index;
    		this.selectedBox=box;
    	},

    	addBox(box){
    		
    		// if(box%2!=0) {
    		// 	this.boxes.push({
    		// 		id: box+1,
    		// 		background: 'linear-gradient(to right bottom, rgb(141, 170, 253), rgb(123, 187, 255), rgb(120, 201, 251), rgb(133, 213, 244), rgb(155, 223, 237))'
    		// 	});
    		// } else {
    		// 	this.boxes.push({
    		// 		id: box+1,
    		// 		background: 'linear-gradient(to right bottom, #fc9fe1, #fdafe6, #febfeb, #ffcef0, #ffddf5)'
    		// 	});
    		// }
    		
    		if(box%2==0) {
				this.boxes.splice(this.selectedIndex+1, 0,{
					id: this.boxes.length+1,
					background: 'linear-gradient(to right bottom, #fc9fe1, #fdafe6, #febfeb, #ffcef0, #ffddf5)'
				});
    		} else {
				this.boxes.splice(this.selectedIndex+1, 0,{
					id: this.boxes.length+1,
					background: 'linear-gradient(to right bottom, rgb(141, 170, 253), rgb(123, 187, 255), rgb(120, 201, 251), rgb(133, 213, 244), rgb(155, 223, 237))'
				});
    		}
    	},
	},

	components: {
        draggable,
    },
}

</script>

<style>
	@import '../../assets/css/sidebar-left.css';
	.multiselect__option--highlight{
		background: #00C6C6;
	}

	.d-block-sm div#v-step-74be903e,
	.d-block-sm div#v-step-74be97c0 {
	    width: 185px;
	    bottom: 70px;
	    position: fixed;
	    left: 1.7%;
	    padding: 10px;
	    z-index: 99;
	}
	.d-block-sm .v-step__content[data-v-aa0cbe42],
	.d-block-sm .v-step__content>div {
	    font-size: 12px;
	    line-height: 20px;
	}
	.d-block-sm .v-step__button[data-v-aa0cbe42] {
	    font-size: .7rem;
	    height: 1.5rem;
	    line-height: 1rem;
	    margin: 0 .1rem;
	    padding: .15rem .8rem;
	    width: auto;
	}
	.d-block-sm .v-step .v-step__arrow[data-v-aa0cbe42]{
		border-top-color: transparent;
	    border-left-color: transparent;
	    border-right-color: transparent;
	    border-width: .8rem .8rem .8rem 0;
	    bottom: -17px;
	    transform: rotate(-45deg);
	    left: 69px;
	}  

	.d-block-sm div#v-step-74be903e {
    	bottom: calc(100vh - 222px);
	    left: 11%;
	}

	.d-block-sm div#v-step-74be903e .v-step__arrow {
		border-top-color: transparent;
	    border-left-color: transparent;
	    border-right-color: transparent;
	    border-width: .8rem .8rem .8rem 0;
	    left: 88px;
	    -webkit-transform: rotate(-45deg);
	    transform: rotate(-225deg);
	    top: -16px;
	}

	@media only screen and (max-width: 640px){
		.d-block-sm .v-step .v-step__arrow[data-v-aa0cbe42] {
		    left: 60px;
		}
	}
	@media only screen and (max-width: 570px){
		.d-block-sm .v-step .v-step__arrow[data-v-aa0cbe42] {
		    left: 53px;
		}
	}
	@media only screen and (max-width: 480px){
		.d-block-sm .v-step .v-step__arrow[data-v-aa0cbe42] {
		    left: 43px;
		}
	}
	@media only screen and (max-width: 420px){
		.d-block-sm div#v-step-74be97c0 {
		    bottom: 65px;
		}
		.d-block-sm .v-step .v-step__arrow[data-v-aa0cbe42] {
		    left: 35px;
		}
	}
	@media only screen and (max-width: 380px){
		.d-block-sm div#v-step-74be903e {
		    left: 4%;
		}
	}
	@media only screen and (max-width: 340px){
		.d-block-sm .v-step .v-step__arrow[data-v-aa0cbe42] {
		    left: 30px;
		}
	}
</style>